import { render, staticRenderFns } from "./pedidosRecurrentes.vue?vue&type=template&id=efc72a08&scoped=true&"
import script from "./pedidosRecurrentes.vue?vue&type=script&lang=js&"
export * from "./pedidosRecurrentes.vue?vue&type=script&lang=js&"
import style0 from "./pedidosRecurrentes.vue?vue&type=style&index=0&id=efc72a08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc72a08",
  null
  
)

export default component.exports